// rockmelon.io Landing Page Content Configuration
// Update this file to change all content on the landing page

export const siteContent = {
  // Set to true when ready to launch the full site
  isLive: false,

  // Company Information
  company: {
    name: "rockmelon",
    displayName: "rockmelon.io",
    tagline: "Solid Foundation. Fresh Results.",
    logo: "/rockmelon_logo.png",
    subtitle: "Executive IT Strategy & CIO Advisory delivering measurable technology transformation across Australia",
    location: "Sydney-Based • Australia-Wide Coverage • Enterprise-Grade Leadership",
    email: "hello@rockmelon.io",
    linkedin: "https://linkedin.com/company/rockmelon-io", // Optional
    calendly: "https://calendly.com/rockmelon-io", // Optional
    abn: "12 345 678 901"
  },

  // Hero Section
  hero: {
    headline1: "Solid Foundation.",
    headline2: "Fresh Results.",
    backgroundImage: "https://images.unsplash.com/photo-1560250163-17506787d971?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMG1lZXRpbmd8ZW58MHx8fGJsdWV8MTc1MjI5MDA3Nnww&ixlib=rb-4.1.0&q=85",
    subtitle: "Bridging complex technology with executive business strategy. We align your IT with business outcomes.",
    metrics: [
      { value: "$1.2M+", label: "Annual Savings Delivered" },
      { value: "99.99%", label: "System Uptime Achieved" },
      { value: "45%", label: "Security Maturity Increase" }
    ],
    ctaPrimary: "Start Your Transformation",
    ctaSecondary: "Explore Success Stories",
    trustIndicators: [
      "Enterprise Security Certified",
      "ISO 27001 Compliant", 
      "20+ Years Experience"
    ]
  },

  // About Section
  about: {
    paragraphs: [
      "rockmelon delivers independent strategic technology leadership without the conflicts of interest that plague traditional consulting. As your fractional CIO, we provide the seasoned expertise of a senior technology executive on a retainer basis, ensuring long-term alignment with your business objectives across Australia.",
      "Our approach focuses on measurable outcomes: cost reduction, security enhancement, and operational excellence. Unlike vendor-driven solutions, our recommendations are based solely on what's best for your organization, backed by decades of enterprise technology leadership experience in the Australian market.",
      "The retainer model ensures continuity, accountability, and deep understanding of your business context. This isn't project-based consulting—it's strategic partnership that evolves with your organization's needs, delivered from Sydney with Australia-wide reach."
    ],
    image: "https://images.unsplash.com/photo-1561731885-e0591a34659c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NTIzMDI5NjF8MA&ixlib=rb-4.1.0&q=85"
  },

  // The rockmelon Approach
  approach: {
    subtitle: "A systematic methodology that delivers measurable results through strategic clarity and execution excellence.",
    phases: [
      {
        title: "Strategy",
        icon: "🎯",
        description: "Comprehensive assessment and strategic roadmap development aligned with business objectives.",
        metric: "90% accuracy in ROI predictions"
      },
      {
        title: "Execution",
        icon: "⚡", 
        description: "Disciplined implementation with clear milestones, accountability, and risk management.",
        metric: "95% on-time delivery rate"
      },
      {
        title: "Oversight",
        icon: "📊",
        description: "Continuous monitoring, optimization, and governance to ensure sustained value delivery.",
        metric: "100% compliance maintenance"
      }
    ],
    backgroundImage: "https://images.unsplash.com/photo-1639815188546-c43c240ff4df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxkYXRhJTIwY2VudGVyfGVufDB8fHxibHVlfDE3NTIyOTAwOTF8MA&ixlib=rb-4.1.0&q=85"
  },

  // Engagement Model / Services
  engagement: {
    subtitle: "Flexible retainer-based partnership designed to scale with your organization's needs and maturity.",
    tiers: [
      {
        name: "Advisory",
        hours: "10-15 hours/month",
        focus: ["Strategic Planning", "Technology Roadmap", "Vendor Evaluation"],
        outcome: "Clear IT direction aligned with business goals",
        popular: false
      },
      {
        name: "Partnered", 
        hours: "20-30 hours/month",
        focus: ["Active Implementation", "Team Leadership", "Process Optimization"],
        outcome: "Measurable improvements in IT performance",
        popular: true // This will show "MOST POPULAR" badge
      },
      {
        name: "Embedded",
        hours: "40+ hours/month",
        focus: ["Full IT Leadership", "Daily Operations", "Strategic Execution"], 
        outcome: "Complete IT transformation and ongoing excellence",
        popular: false
      }
    ]
  },

  // Outcomes/Results
  outcomes: {
    subtitle: "Measurable results that directly impact your bottom line and operational excellence.",
    metrics: [
      { value: "$1.2M", label: "Saved in Cloud Spend" },
      { value: "45%", label: "Security Maturity Increase" },
      { value: "99.99%", label: "System Uptime" },
      { value: "30 Days", label: "Audit Ready" }
    ]
  },

  // Client Stories / Case Studies
  caseStudies: {
    subtitle: "Real challenges. Strategic solutions. Measurable impact.",
    stories: [
      {
        title: "Fortune 500 Manufacturing",
        challenge: "Legacy systems causing $2M annual downtime",
        strategy: "Cloud migration with zero-downtime transition plan", 
        outcome: "98% reduction in system failures, $1.8M annual savings"
      },
      {
        title: "Healthcare Network",
        challenge: "Security compliance gaps threatening operations",
        strategy: "Comprehensive security framework implementation",
        outcome: "100% compliance achieved, zero security incidents in 18 months"
      },
      {
        title: "Financial Services Firm", 
        challenge: "IT costs spiraling out of control",
        strategy: "Vendor consolidation and process optimization",
        outcome: "32% cost reduction while improving service quality"
      }
    ]
  },

  // Non Profit Services
  nonprofit: {
    subtitle: "Specialized technology strategy for mission-driven organizations. Maximizing impact while optimizing costs and ensuring transparency.",
    services: [
      {
        title: "Technology Strategy for Impact",
        description: "Maximizing mission delivery through strategic technology decisions and donor stewardship systems.",
        icon: "🎯"
      },
      {
        title: "Compliance & Security", 
        description: "Ensuring donor data protection, financial transparency, and regulatory compliance at scale.",
        icon: "🛡️"
      },
      {
        title: "Grant & Fundraising Tech",
        description: "Implementing CRM, donor management, and grant tracking systems that scale with growth.",
        icon: "💝"
      },
      {
        title: "Volunteer Management",
        description: "Digital platforms for volunteer coordination, training, and engagement optimization.", 
        icon: "🤝"
      }
    ],
    benefits: [
      "Board-level technology governance and reporting",
      "Grant application and compliance technology requirements", 
      "Donor data security and privacy protection",
      "Mission-focused technology ROI optimization",
      "Volunteer and community engagement platforms"
    ],
    metrics: {
      costReduction: "40%",
      costReductionLabel: "Average cost reduction for NFP technology spend",
      compliance: "100%", 
      complianceLabel: "Compliance rate across all NFP clients"
    }
  },

  // Testimonials
  testimonials: {
    reviews: [
      {
        quote: "rockmelon transformed our IT from a cost center to a strategic advantage. Their independence meant we got honest advice, not vendor pitches.",
        author: "Sarah Chen",
        role: "CFO, TechCorp Industries", 
        image: "https://images.pexels.com/photos/3358301/pexels-photo-3358301.jpeg"
      },
      {
        quote: "The ROI was immediate and substantial. rockmelon's retainer model gave us access to CTO-level expertise at a fraction of the cost.",
        author: "Michael Rodriguez",
        role: "CEO, GrowthVentures",
        image: "https://images.pexels.com/photos/7616608/pexels-photo-7616608.jpeg"
      }
    ]
  },

  // Contact Form
  contact: {
    subtitle: "Ready to align your technology with business outcomes? Let's discuss how rockmelon can deliver measurable results for your Australian organization.",
    buttonText: "Send Message"
  }
};
